export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              欢迎影视爱好者投稿、咨询合作或反馈建议，西瓜影视期待您的来信
            </p>
          </div>

          <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">投稿邮箱</h3>
                <p className="text-xs text-foreground-500">submit@xigua.movie</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-chat-smile-2-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">合作咨询</h3>
                <p className="text-xs text-foreground-500">coop@xigua.movie</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-feedback-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">问题反馈</h3>
                <p className="text-xs text-foreground-500">help@xigua.movie</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}